import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";

import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import style from "./ProstateAdditionalInfoForm.module.css";

export const ProstatePrevField = ({ form, name, label }) => {
  const shouldShowRestFields = form.watch(name) === "yes";

  return (
    <>
      <FormField name={name}>
        <div className={style.formItemWrapper}>
          <label className={style.addReferralFormLabel}>{label}</label>
          <div style={{ color: "#F72924" }}>*</div>

          <div className={style.winXpSelectWrapper} style={{ width: "150px" }}>
            <Select
              name={name}
              options={[
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
              ]}
              value={form.watch(name)}
              onChange={(value) => {
                form.setValue(name, value);
              }}
              required
            />
          </div>
        </div>
      </FormField>

      {shouldShowRestFields && (
        <>
          <div className={style.formItemWrapper} style={{ marginTop: "-4px" }}>
            <div></div>
            <div></div>
            <FormField name={name + "Hospital"}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    width: "80px",
                    fontWeight: "400",
                    fontSize: "13px",
                  }}
                >
                  Hospital
                </label>
                <input
                  className={style.winXpInputWrapper}
                  style={{ minWidth: "320px" }}
                  {...form.register(name + "Hospital")}
                />
              </div>
            </FormField>
          </div>
          <div className={style.formItemWrapper} style={{ marginTop: "-4px" }}>
            <div></div>
            <div></div>
            <FormField name={name + "Date"}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    width: "80px",
                    fontWeight: "400",
                    fontSize: "13px",
                  }}
                >
                  Date
                </label>
                <div
                  className={`${style.addPregnancyDatePickerWrapper} ${style.winXpDatepickerWrapper}`}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      name={name + "Date"}
                      value={
                        form.watch(name + "Date")
                          ? dayjs(form.watch(name + "Date"), "DD-MM-YYYY")
                          : null
                      }
                      sx={{
                        width: "100%",
                        height: "36px",
                      }}
                      onChange={(newValue) => {
                        form.setValue(
                          name + "Date",
                          newValue
                            ? moment(new Date(dayjs(newValue))).format(
                                "DD-MM-YYYY"
                              )
                            : null
                        );
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </FormField>
          </div>
          <div className={style.formItemWrapper} style={{ marginTop: "-4px" }}>
            <div></div>
            <div></div>
            <FormField name={name + "Result"}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    width: "80px",
                    fontWeight: "400",
                    fontSize: "13px",
                  }}
                >
                  Result
                </label>
                <div
                  className={style.winXpSelectWrapper}
                  style={{ minWidth: "154px" }}
                >
                  <Select
                    name={name}
                    options={[
                      { label: "Normal", value: "Normal" },
                      { label: "Abnormal", value: "Abnormal" },
                      { label: "Unknown", value: "Unknown" },
                    ]}
                    value={form.watch(name + "Result")}
                    onChange={(value) => {
                      form.setValue(name + "Result", value);
                    }}
                    required
                  />
                </div>
              </div>
            </FormField>
          </div>
        </>
      )}
    </>
  );
};
